import { format, parse } from 'date-fns'

// https://date-fns.org/v1.30.1/docs/format

const customDate = {}

function formatDate (date, formatString = 'EEEE, MMMM d, yyyy', parseString = 'yyyy-MM-dd') {
  if (date === '') { return '' }
  const parseDate = parse(date, parseString, new Date())
  return format(parseDate, formatString)
}

customDate.install = function (Vue) {
  Vue.filter('custom-date', (value, format) => {
    return formatDate(value, format)
  })
}

export default customDate
